import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const MenuSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="24" height="24" viewBox="0 0 24 24" fill="none"
             className={classNames(['svg-icon svg-user', className])}>
            <path d="M2 6H22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M2 12H22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M2 18H22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>

    );
};

MenuSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

MenuSVG.defaultProps = {
    color: '#4FBABF',
    className: '',
};

export default MenuSVG;